import { defineComponent, openBlock, createElementBlock, createVNode, unref, createElementVNode, createTextVNode, toDisplayString } from "vue";
import { IconWarningStroke } from "@rei/cedar";
const _hoisted_1 = {
  class: "prop65",
  "data-ui": "prop-65-message"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Prop65Modal",
  props: {
    message: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createVNode(unref(IconWarningStroke), {
        class: "prop65__icon",
        "data-ui": "prop-65-icon"
      }), createElementVNode("span", null, [_cache[0] || (_cache[0] = createElementVNode("strong", {
        class: "prop65--strong"
      }, "WARNING: ", -1)), createTextVNode(toDisplayString(_ctx.message), 1)])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Prop65Modal2.mjs.map
